import { ComplianceLayout, COMPANY } from "@/components/ComplianceLayout";

export default function Complaints() {
  return (
    <ComplianceLayout
      kicker="Compliance"
      title="Complaints & Disputes"
      description="OzyLoans complaints and dispute resolution process — internal dispute resolution within 30 days under ASIC RG 271, and AFCA external dispute resolution."
      path="/complaints"
    >
      <p>We take all complaints seriously and aim to resolve them quickly and fairly through our internal dispute resolution (IDR) process.</p>

      <h2>Step 1 — Talk to us</h2>
      <p>Please contact us first so we can try to resolve your complaint:</p>
      <ul>
        <li>Email: <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a></li>
        <li>Phone: <a href={`tel:${COMPANY.phoneTel}`}>{COMPANY.phone}</a></li>
        <li>Mail: {COMPANY.addressLine1}, {COMPANY.addressLine2}, {COMPANY.addressLine3}</li>
      </ul>
      <p>We will acknowledge your complaint within 1 business day and provide a written response within <strong>30 days</strong> in line with ASIC RG 271.</p>

      <h2>Step 2 — External dispute resolution</h2>
      <p>If you are not satisfied with our response, you can refer your complaint at no cost to:</p>
      <ul>
        <li><strong>Australian Financial Complaints Authority (AFCA)</strong></li>
        <li>{COMPANY.name} member number: <strong>{COMPANY.afca}</strong></li>
        <li>Phone: <a href="tel:1800931678">1800 931 678</a></li>
        <li>Email: <a href="mailto:info@afca.org.au">info@afca.org.au</a></li>
        <li>Web: <a href="https://www.afca.org.au" target="_blank" rel="noopener noreferrer">afca.org.au</a></li>
        <li>Mail: GPO Box 3, Melbourne VIC 3001</li>
      </ul>

      <h2>Other regulators</h2>
      <p>You can also contact <strong>ASIC</strong> on <a href="tel:1300300630">1300 300 630</a> or via <a href="https://asic.gov.au" target="_blank" rel="noopener noreferrer">asic.gov.au</a>, or the <strong>OAIC</strong> for privacy matters at <a href="https://oaic.gov.au" target="_blank" rel="noopener noreferrer">oaic.gov.au</a>.</p>
    </ComplianceLayout>
  );
}
